import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Container, Grid } from 'semantic-ui-react';
import { UniversalLink, PreviewImage} from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { BodyClass } from '@plone/volto/helpers';
import { filter, map, isEmpty } from 'lodash';
import { flattenToAppURL, toPublicURL } from '@plone/volto/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';


const BlogUnfolded = ({ content }) => {
    const items = filter(content.items, (item) => {
        return item['@type'] !== 'Image' && !item.exclude_from_nav;
    });

    const dispatch = useDispatch();
    const rawItems = useSelector(
      (state) => state.search.subrequests.items?.items || [],
      shallowEqual
    );

    const allItems = useMemo(
      () =>
        map(rawItems, (item) => ({
          ...item,
          '@id': toPublicURL(item['@id']),
        })),
      [rawItems]
    );

    const getViewURL = function (item) {
        let URL = flattenToAppURL(item['@id']);
        if (item['@type'] === 'File') {
            URL += '/@@display-file/file';
        }
        if (item['@type'] === 'Image') {
            URL += '/@@display-file/image';
        }
        if (item?.getRemoteUrl) {
            URL = item?.getRemoteUrl;
        }
        return URL;
    };

    const getSubItems = function (itemID, subItems, mainItem) {
        return filter(subItems, (item) => {
            return item['@id'].includes(itemID) && item['@id'] !== itemID;
        });
    };

    useEffect(() => {
        let contentFilter = {
            b_size: 360,
            sort_on: 'getObjPositionInParent',
            metadata_fields: ['content_icon', 'getRemoteUrl'],
        };
        contentFilter['path.depth'] = 2
        dispatch(searchContent(flattenToAppURL(content['@id']), contentFilter, 'items'));
    }, [dispatch]);

    return (
        <>
            <BodyClass className="blogUnfolded" />

            {content.enable_announcements && <Announcements content={content} />}

            <Container id="content-core" className="blogUnfolded__page pt-5 list-unstyled my-0" as="ul">

                {items.map((item) => (
                    <li key={item['@id']} className='mb-4' >
                        <article className={'blogUnfoldedItem' + (item.image_field ? ' blogUnfoldedItem--hasImage' : ' blogUnfoldedItem--noImage')}>
                            <div className="blogUnfoldedItem__header">
                                <h2 className="blogUnfoldedItem__title h3 my-0">
                                    <UniversalLink
                                        href={getViewURL(item)}
                                        className="blogUnfoldedItem__link " >{item.title}
                                    </UniversalLink>
                                </h2>
                                {item.description && (
                                    <p className="blogUnfoldedItem__desc ">
                                        {item.description}
                                    </p>
                                )}
                            </div>
                            {getSubItems(item['@id'], allItems, item) &&
                            <>
                                {getSubItems(item['@id'], allItems, item)?.length > 0 && (
                                    <ul className='blogUnfoldedItem__children list-unstyled'>
                                        {getSubItems(item['@id'], allItems).map((item) => (
                                            <li key={item['@id']} className='blogUnfoldedItem__children__item mb-3'>
                                                <UniversalLink href={getViewURL(item)} className="blogUnfoldedItem__children__link" >
                                                    <strong className="blogUnfoldedItem__children__text">{item.title}</strong>
                                                    <FontAwesomeIcon className="blogUnfoldedItem__children__icon" icon={faArrowRight} />
                                                </UniversalLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                            }
                        </article>


                    </li>
                ))}

            </Container>
        </>
    );
};

export default BlogUnfolded;